import React, { useEffect, useState } from 'react';

const radioSelectorStyle = {
  container: {
    height: '27px',
    width: '200px',
    marginLeft: '25px',
    display: 'flex',
    boxSizing: 'border-box',
  },
  selected: {
    backgroundColor: '#fff',
    color: '#a5c946',
  },
  notSelected: {
    cursor: 'pointer',
  },
};

const SelectorTypeDemandePassage = (props) => {
  const { leftValue, rightValue } = props;
  const [value, setValue] = useState(props.value);

  // Gestion des appels API lors du changement de valeur du radio
  useEffect(() => {
    props.onChange(value);
  }, [value]);

  // Render du composant
  return (
    <div style={radioSelectorStyle.container}>
      <div
        className="radio-selector left-radio-selector"
        style={props.value === 'superieur' ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue('superieur')}
      >
        {leftValue}
      </div>
      <div
        className="radio-selector right-radio-selector"
        style={props.value === 'autoroute' ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue('autoroute')}
      >
        {rightValue}
      </div>
    </div>
  );
};

export default SelectorTypeDemandePassage;
